export const AUTO_HIDE_DURATION = 2000;